import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import { BootstrapTable, TableHeaderColumn, defaultSortName, defaultSortOrder } from 'react-bootstrap-table'
import { Button } from 'react-bootstrap'
import moment from 'moment'

import Collapsible from './collapsible'
import Loadable from 'react-loading-overlay'
import NewlyAssigned from './tasks/newlyassigned'

@observer(['companies', 'partners', 'tasks', 'globals'])
export default class Dashboard extends Component {

  constructor(props) {
    super(props)
    let isRestricted = localStorage.getItem('userId') === "30";
    this.state = {
      overviewLoadable: true,
      ristrictedUser: isRestricted ? isRestricted : false,
      sourceLeadCountByMonthLoadable: true,
      newCompanyLoadable: true,
      showLeadCountBreakdown: false,
      leadCountBreakdownLoadable: false
    }

    this.props.globals.setCurrentPage('dashboard')

    let promises = [];

    promises.push(this.props.companies.countLeads());
    promises.push(this.props.companies.countCustomers());
    promises.push(this.props.companies.countInactive());
    promises.push(this.props.partners.countPartners());

    Promise.all(promises).then((results) => {
      this.loadProcess()
    }).catch((err) => {
      alert(err)
    })
  }

  loadProcess() {
    this.setState({
      overviewLoadable: false
    })

    this.props.companies.loadNewlyAssignedCompanies(() => {
      this.setState({
        newCompanyLoadable: false
      })
    })

    this.props.companies.loadLeadCountByMonth(() => {
      console.log('Lead Count By Month: ', this.props.companies.leadCountByMonth)
      this.setState({
        sourceLeadCountByMonthLoadable: false
      })
    })
  }

  deleteCompany(id) {
    this.setState({
      newCompanyLoadable: true
    })

    if (confirm('Are you sure you want to delete this ' + this.props.companyTypeHeading + '?')) {
      this.props.companies.deleteCompany({
        id: id,
        hash: localStorage.getItem('userHash')
      }, () => {
        this.props.companies.loadNewlyAssignedCompanies(() => {
          this.setState({
            newCompanyLoadable: false
          })
        })
      })
    } else {
      this.setState({
        newCompanyLoadable: false
      })
    }
  }

  getLeadCountBreakdown(startDate, endDate) {
    this.setState({
      showLeadCountBreakdown: true,
      leadCountBreakdownLoadable: true,
      leadCountBreakdown: true

    })

    this.props.companies.getLeadCountBreakdown(startDate, endDate, () => {
      this.setState({
        leadCountBreakdownLoadable: false
      })
    })
  }

  formatActions(cell, row) {

    return (
      <div>
        <Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { browserHistory.push('/company/details/' + row.id) } }><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
        { /* <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteCompany(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button> */ }
      </div>
    )
  }
  render() {
    const options = {
      defaultSortName: 'name',  // default sort column name
      defaultSortOrder: 'asc'  // default sort order
    }

    var overviewPanel = (
      <div>
        <Loadable active={ this.state.overviewLoadable } spinner text='Processing your request...'>
        <div className="row tile_count">
          <div className="col-md-2 col-sm-4 col-xs-6 tile_stats_count">
            <span className="count_top"><i className="fa fa-user"></i> Total Leads</span>
            <div className="count">{ this.props.companies.leadsCount }</div>
          </div>
          <div className="col-md-2 col-sm-4 col-xs-6 tile_stats_count">
            <span className="count_top"><i className="fa fa-user"></i> Total Customers</span>
            <div className="count">{ this.props.companies.customersCount }</div>
          </div>
          <div className="col-md-2 col-sm-4 col-xs-6 tile_stats_count">
            <span className="count_top"><i className="fa fa-user"></i> Total Inactive</span>
            <div className="count">{ this.props.companies.inactiveCount }</div>
          </div>
          <div className="col-md-2 col-sm-4 col-xs-6 tile_stats_count">
            <span className="count_top"><i className="fa fa-user"></i> Total Partners</span>
            <div className="count">{ this.props.partners.partnersCount }</div>
          </div>
        </div>
        </Loadable>
        <div>

        </div>
      </div>
    )
    
    let monthlyLeadCountPanel = ''

    if (this.props.companies.leadCountByMonth.length > 0) {
      monthlyLeadCountPanel = (
        <div>
          <Loadable active={ this.state.sourceLeadCountByMonthLoadable } spinner text='Processing your request...'>

          <div className="row tile_count">
            {
              this.props.companies.leadCountByMonth.map((item) => {
                let countText = <div className="count">0</div>
                if (item.leadCount > 0) {
                  countText = <div className="count showPointer" onClick={ () => { this.getLeadCountBreakdown(item.startDate, item.endDate) } }>{ item.leadCount }</div>
                }

                return (
                  <div className="col-md-2 col-sm-4 col-xs-6 tile_stats_count">
                    <span className="count_top"><i className="fa fa-user"></i> { moment(item.month).format('MMMM YYYY') }</span>
                    { countText }
                  </div>
                )
              })
            }
          </div>
          </Loadable>
        </div>
      )
    }

    let leadCountBreakdownPanel = ''

    if (this.props.companies.leadCountBreakdown.length > 0) {
      leadCountBreakdownPanel = (
        <div>
          <Loadable active={ this.state.leadCountBreakdownLoadable } spinner text='Processing your request...'>
          <BootstrapTable
              data={ this.props.companies.leadCountBreakdown }
              striped={ true }
              hover={ true }
              pagination={ true }
              search={ true }
              exportCSV={ true }
              bordered={ true }
              options={ options }
              >
            <TableHeaderColumn width="100" isKey={true} dataField="name" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Company</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="fullName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Contact</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="email" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Email</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="phone" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Phone</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="address" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Address</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="userFullName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Assigned</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="vendorName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Vendor</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="sourceName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Source</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
          </BootstrapTable>
          </Loadable>
        </div>
      )
    }

    let newlyAssignedCompaniesTable = ''

    if (this.props.companies.assigned.length > 0) {
      newlyAssignedCompaniesTable = (
      <div>
        <Loadable active={ this.state.newCompanyLoadable } spinner text='Processing your request...'>
          <BootstrapTable
              data={ this.props.companies.assigned }
              striped={ true }
              hover={ true }
              pagination={ true }
              search={ true }
              exportCSV={ true }
              bordered={ true }
              options={ options }
              >
            <TableHeaderColumn width="100" isKey={true} dataField="name" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Company</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="fullName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Contact</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="email" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Email</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="phone" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Phone</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="address" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Address</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="userFullName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Assigned</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="vendorName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Vendor</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="sourceName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Source</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
          </BootstrapTable>
        </Loadable>
      </div>
    )
  }

  var newlyAssignedTasksTable = (
    <div>
      <Loadable active={ this.state.newTasksLoadable } spinner text='Processing your request...'>
        <NewlyAssigned data={ this.props.tasks.newAssigned } />
      </Loadable>
    </div>
  )

  let leadCountBreakdownCollapsible = ''

  if (this.state.showLeadCountBreakdown) {
    leadCountBreakdownCollapsible = (
      <div>
        <Collapsible title="Lead Count Breakdown" content={ leadCountBreakdownPanel } />
        <div className="clearfix"></div>
      </div>
    )
  }

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        {localStorage.getItem('userId') === "30" ? null : <Collapsible title="Overview" content={ overviewPanel } />}
        <div className="clearfix"></div>
        {localStorage.getItem('userId') === "30" ? null : <Collapsible title="Leads By Month" content={ monthlyLeadCountPanel } />}
        <div className="clearfix"></div>
        { leadCountBreakdownCollapsible }
        <Collapsible title="Newly Assigned Companies" content={ newlyAssignedCompaniesTable } />
        <div className="clearfix"></div>
        <Collapsible title="Newly Assigned Tasks" content={ newlyAssignedTasksTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard.js